export default {
  dark: 'Tamno',
  light: 'Svjetlo',
};
